class INTENT.widgets.SwitcherGroup

    @ATTR_NAME: "data-widget-switcher-group"

    @CLASS_CURRENT: "switch-current"

    constructor: (@el) ->
        @s = @.constructor

        group = @el.attr 'data-widget-switcher-group'

        unless group
            @switchers_collection = @el.find ".on-off"
        else
            @switchers_collection = @el.find ".on-off.group-#{group}"

        @switchers_collection.on 'switchChange.bootstrapSwitch', (e, state) =>
            current = $ e.currentTarget
            current.addClass @s.CLASS_CURRENT
            if state
                @switchers_collection.filter(":not(.#{@s.CLASS_CURRENT})").bootstrapSwitch 'state', false
                current.removeClass @s.CLASS_CURRENT
